import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { remoteImageUrlsInText } from "@seabrookstudios/pitch2table-core";

/**
 * @param {object} props
 * @param {string} props.text
 * @param {boolean} props.enabled
 * @returns {React.JSX.Element|null}
 */
export const RemoteInboxImages = ({ text, enabled }) => {
  const [shown, setShown] = useState(false);
  const urls = enabled ? remoteImageUrlsInText(text) : [];

  if (urls.length === 0) {
    return null;
  }

  if (!shown) {
    return (
      <Button size="small" onClick={() => setShown(true)} sx={{ alignSelf: "flex-start" }}>
        Show images
      </Button>
    );
  }

  return (
    <Stack spacing={1}>
      {urls.map((url) => (
        <Box key={url} component="img" src={url} alt="Email image" sx={{ maxWidth: "100%", height: "auto" }} />
      ))}
    </Stack>
  );
};
